import useFeature from '@/contexts/FeatureFlags/useFeature';

/**
 * «תמיכות שחוזרות: חשבון בנק חדש» (HAT-1395). Must match FeatureFlagKeys.ReturnedPaymentNewAccount
 * on the server and the row seeded by SeedFeatureFlag_ReturnedPaymentNewAccount.sql.
 *
 * Gates the office half - deleting the account a payment bounced from and mailing the
 * coordinators - read through the global provider, since the management area belongs to no fund.
 * The coordinator half is not gated: it shows only accounts deleted through this half.
 */
export const RETURNED_PAYMENT_FEATURE_KEY = 'returned-payment-new-account';

export default function useReturnedPaymentFeature(): boolean {
  return useFeature(RETURNED_PAYMENT_FEATURE_KEY);
}
